import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';

class ResponseMaker {
    data = [];
    data_to_send = {
        orderHeaderDetail: {}
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        if (this.data.orderDetailPayload && this.data.orderDetailPayload.orderDetails) {
            let here_v = {}
            let orderHeaderDetail = this.data.orderDetailPayload.orderDetails

            if (orderHeaderDetail.purchaseOrderNumber) {
                here_v.purchaseOrderNumber = orderHeaderDetail.purchaseOrderNumber
            }
            if (orderHeaderDetail.webOrderNumber) {
                here_v.webOrderNumber = orderHeaderDetail.webOrderNumber
            }
            if (orderHeaderDetail.sapOrderNumber) {
                here_v.orderNumber = orderHeaderDetail.sapOrderNumber === '' || orderHeaderDetail.sapOrderNumber === null || orderHeaderDetail.sapOrderNumber === 'N/A' ? orderHeaderDetail.webOrderNumber : orderHeaderDetail.sapOrderNumber

            }
            if (orderHeaderDetail.sapOrderNumber) {
                here_v.sapOrderNumber = orderHeaderDetail.sapOrderNumber
            }
            if (orderHeaderDetail.orderStatus) {
                here_v.orderStatus = orderHeaderDetail.orderStatus 
            }
            if (orderHeaderDetail.orderStatusName) {
                here_v.orderStatusName = orderHeaderDetail.orderStatusName.toLowerCase() === 'pending' ? 'Order Placed' : orderHeaderDetail.orderStatusName
            }
            if (orderHeaderDetail.buyerName) {
                here_v.buyerName = orderHeaderDetail.buyerName
            }
            if (orderHeaderDetail.buyerEmail) {
                here_v.buyerEmail = orderHeaderDetail.buyerEmail
            }
            if (orderHeaderDetail.buyerContact) {
                here_v.buyerContact = orderHeaderDetail.buyerContact
            }
            if (orderHeaderDetail.soldToParty) {
                here_v.billingAddress = orderHeaderDetail.soldToParty
            }
            if (orderHeaderDetail.shipToParty) {
                here_v.shippingAddress = orderHeaderDetail.shipToParty
            }
            if (orderHeaderDetail.shippingConditions) {
                here_v.shippingMethod = orderHeaderDetail.shippingConditions
            }
            if (orderHeaderDetail.itemLines && orderHeaderDetail.itemLines.length > 0) {
                let invoiceArr = []
                let trackingNumArr = []
                let carrierArr = {}
                orderHeaderDetail.itemLines.map((v, i) => {
                    if (v.invoiceNum && v.invoiceNum.trim() !== "" && v.invoiceNum.trim() !== "N/A") {
                        invoiceArr.push(v.invoiceNum)
                    }
                    if (v.trackNumber && v.trackNumber.trim() !== "" && v.trackNumber.trim() !== "N/A") {
                        trackingNumArr.push(v.trackNumber)
                    }
                    if(v.carrier && v.carrier.trim()!=="")
                    {
                        if(carrierArr[v.trackNumber] == undefined)
                        {
                            carrierArr[v.trackNumber] = {};
                            carrierArr[v.trackNumber]['carrier'] = v.carrier;
                        }
                        else
                        {
                            carrierArr[v.trackNumber]['carrier'] = v.carrier
                        }
                    }
                })
                here_v.invoice = invoiceArr
                here_v.trackingNumber = trackingNumArr
                here_v.carrier = carrierArr
            }

            if (orderHeaderDetail.customerAccountNumber) {
                here_v.customerAccountNumber = orderHeaderDetail.customerAccountNumber
            }
            if (orderHeaderDetail.orderType) {
                here_v.orderType = orderHeaderDetail.orderType
            }
            if (orderHeaderDetail.orderDate) {
                here_v.orderDate = orderHeaderDetail.orderDate
                here_v.finalOrderDate = Helper.dateFormatFromString(orderHeaderDetail.orderDate)
            }


            this.data_to_send.orderHeaderDetail = here_v
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;